// @ts-strict-ignore
import { component } from "picoapp";
import { type Context, type SelectedVariant } from "../../state";

export const variantShippingNote = component<Context>((node, context) => {
  const { productHandle } =
    node.closest<HTMLElement>("[data-product-handle]")?.dataset ?? {};
  const formElement = document.querySelector<HTMLFormElement>(
    `form[id="product-form"]`
  );
  const currentOptionCategory = node.closest<HTMLElement>(
    "[data-option-category]"
  )?.dataset.optionCategory;

  if (!productHandle || !formElement) {
    return;
  }

  const isShopifyBundle = formElement.dataset.shopifyBundle === "true";

  const getBundleProductVariantShippingNote = (
    selectedVariant: SelectedVariant,
    productOptionIndex
  ) => {
    const bundleProductName = selectedVariant.selectedOptions[
      productOptionIndex
    ].name.replace(/ *\([^)]*\) */g, "");
    return document.querySelector<HTMLOptionElement>(
      `select[name="shopify-bundle-metadata"] optgroup[label="${bundleProductName}"] option[value="${selectedVariant.selectedOptions[productOptionIndex].value}"]`
    )?.dataset?.variantShippingNote;
  };

  context.on("tbsp:variant-selected", ({ selectedVariant }) => {
    if (selectedVariant.handle !== productHandle) {
      return;
    }

    node.querySelector("[data-tbsp-component='text']").textContent = "";

    if (
      currentOptionCategory &&
      currentOptionCategory !== selectedVariant.optionCategory
    ) {
      return;
    }

    let newShippingNote = selectedVariant.shippingNote;

    if (isShopifyBundle) {
      const productOptionIndex = Number(
        node.closest<HTMLFieldSetElement>("fieldset")?.dataset
          ?.productOptionIndex
      );

      newShippingNote = getBundleProductVariantShippingNote(
        selectedVariant,
        productOptionIndex
      );
    }

    node.querySelector("[data-tbsp-component='text']").textContent =
      newShippingNote ?? "";
  });
});
